import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setSearchValue } from '../../Stores/Action/AppAction';
import { modena_logo_putih } from '../../Images';

const Footer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [search, setSearch] = useState('');

  const onExploreClick = (param) => {
    setSearch(param);
    dispatch(setSearchValue(param));
    navigate('/asset/search');
  }

  const onSearchClick = () => {
    dispatch(setSearchValue(search));
    navigate('/asset/search');
  }

  useEffect(() => {
    //window.loadTree();
  }, []);
  
  return (
    <footer className="footer-04" style={{ paddingTop: `3em` }}>
      <div className="container" style={{ height: 310 }}>
        <div className="row">
          <div className="col-md-6 col-lg-3 mb-md-0 mb-4">
            <h2 className="footer-heading" style={{ fontFamily: 'Inter', fontWeight: 700, fontSize: 14, color: `rgba(255, 255, 255, 0.85)`}}>CONTENT</h2>
            <ul className="list-unstyled">
              <li><a href="#" className="py-1 d-block" style={{ fontFamily: 'Inter', fontWeight: 700, fontSize: 14, color: `#869FB2`}} onClick={() => onExploreClick('New Assets')}>New assets</a></li>
              <li><a href="#" className="py-1 d-block" style={{ fontFamily: 'Inter', fontWeight: 700, fontSize: 14, color: `#869FB2`}} onClick={onSearchClick}>The most popular page</a></li>
              <li><a href="#" className="py-1 d-block" style={{ fontFamily: 'Inter', fontWeight: 700, fontSize: 14, color: `#869FB2`}} onClick={() => onExploreClick('Most search')}>Search trends</a></li>
            </ul>
          </div>
          <div className="col-md-6 col-lg-3 mb-md-0 mb-4">
            <h2 className="footer-heading"></h2>
            <ul className="list-unstyled">
              <li><a href="#" className="py-1 d-block"></a></li>
            </ul>
          </div>
          <div className="col-md-6 col-lg-3 mb-md-0 mb-4">
            
          </div>
          <div className="col-md-6 col-lg-3 mb-md-0 mb-4">
            <h2 className="footer-heading" style={{ fontFamily: 'Inter', fontWeight: 700, fontSize: 14, color: `rgba(255, 255, 255, 0.85)`}}>INFORMATION</h2>
            <ul className="list-unstyled">
              <li><a href="#" className="py-1 d-block" style={{ fontFamily: 'Inter', fontWeight: 700, fontSize: 14, color: `#869FB2`}}>About us</a></li>
              {/* <li><a href="#" className="py-1 d-block">Contact</a></li> */}
            </ul>
          </div>
        </div>
      </div>
      <div className="container">
        <hr style={{ border: `1px solid #374957`, marginBottom: 0 }}/>
      </div>
      <div className="w-100 border-top py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-8 inline">
              <img src={modena_logo_putih}></img><span className="copyright" style={{ marginLeft: 10, ontFamily: 'Inter', fontWeight: 400, fontSize: 14, color: `#BAC8D3`}}>Copyright © 2022 All rights reserved.</span>
            </div>
          </div>
        </div>
      </div>
      <div className="w-100" style={{height: '43.23px', background: 'rgba(55, 73, 87, 0.5)'}} />
    </footer>
  )
}

export default Footer;